<template>
  <div>
    <custom-actions>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="searchForm.supplierId" clearable filterable placeholder="请选择供应商">
            <el-option v-for="(item) of supplierArr" :value="item.userId" :label="item.userName" :key="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="供应商" prop="supplierName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="采购单数量" prop="orderNum"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="提货单数量" prop="deliveryNum"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="应付款" prop="purchasePrice">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.replace('/purchaseDelivery/list?userId=' + row.supplierId)">{{ row.purchasePrice }}</el-button>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="已付款" prop="paidAmount">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.replace('/supplierPayment/list?userId=' + row.supplierId)">{{ row.paidAmount }}</el-button>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="结余货款" prop="purchaseJy"></el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'PurchaseInvoiceCount',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        supplierId: null
      },
      //
      statusArr: [
        {
          label: '未开',
          value: '1'
        },
        {
          label: '已开',
          value: '2'
        }
      ],
      supplierArr: []
    }
  },
  computed: {

  },
  created() {
    this.loadUser()
    this.loadData()
  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.supplierArr = res || []
      })
      // this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '4' }).then(res => {
      //   this.supplierArr = res.list || []
      // })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderCount, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        status: null,
        supplierId: null
      }
      this.loadOrder()
      this.onSearch()
    },

    deleteRow(invoiceId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseInvoice.deleteYcInvoice, {
          invoiceId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
